import { Link } from "react-router-dom";
import { Briefcase, Linkedin, Twitter, Facebook, Instagram, Mail, Phone, MapPin } from "lucide-react";

export default function Footer() {
  return (
    <footer data-testid="site-footer" className="bg-slate-900 text-slate-300 mt-24">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-14 lg:py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10">
          <div>
            <Link to="/" className="flex items-center gap-2">
              <span className="w-9 h-9 rounded-xl bg-gradient-to-br from-blue-500 via-indigo-500 to-sky-400 grid place-items-center text-white shadow">
                <Briefcase size={18} strokeWidth={2.5} />
              </span>
              <span className="font-display text-xl font-extrabold text-white">
                Career<span className="text-indigo-300">Connect</span>
              </span>
            </Link>
            <p className="mt-4 text-sm text-slate-400 leading-relaxed">
              Connecting talent with better opportunities. Submit your enquiry and discover roles that match your ambition.
            </p>
            <div className="mt-5 flex gap-2">
              {[
                { Icon: Linkedin, label: "linkedin" },
                { Icon: Twitter, label: "twitter" },
                { Icon: Facebook, label: "facebook" },
                { Icon: Instagram, label: "instagram" },
              ].map(({ Icon, label }) => (
                <a
                  key={label}
                  href="#"
                  data-testid={`social-${label}`}
                  className="w-9 h-9 grid place-items-center rounded-full bg-slate-800 hover:bg-indigo-600 text-slate-300 hover:text-white transition"
                >
                  <Icon size={16} />
                </a>
              ))}
            </div>
          </div>

          <div>
            <p className="text-xs font-semibold uppercase tracking-[0.18em] text-indigo-300">Quick Links</p>
            <ul className="mt-5 space-y-3 text-sm">
              <li><Link to="/" className="hover:text-white">Home</Link></li>
              <li><Link to="/jobs" className="hover:text-white">Jobs</Link></li>
              <li><Link to="/enquiry" className="hover:text-white">Job Enquiry</Link></li>
              <li><Link to="/about" className="hover:text-white">About Us</Link></li>
              <li><Link to="/contact" className="hover:text-white">Contact Us</Link></li>
            </ul>
          </div>

          <div>
            <p className="text-xs font-semibold uppercase tracking-[0.18em] text-indigo-300">Company</p>
            <ul className="mt-5 space-y-3 text-sm">
              <li><Link to="/privacy" className="hover:text-white">Privacy Policy</Link></li>
              <li><Link to="/terms" className="hover:text-white">Terms &amp; Conditions</Link></li>
              <li><Link to="/admin/login" className="hover:text-white">Admin Portal</Link></li>
            </ul>
          </div>

          <div>
            <p className="text-xs font-semibold uppercase tracking-[0.18em] text-indigo-300">Reach Us</p>
            <ul className="mt-5 space-y-3 text-sm text-slate-400">
              <li className="flex items-start gap-2"><Mail size={15} className="mt-0.5 text-indigo-300" /> hello@careerconnect.io</li>
              <li className="flex items-start gap-2"><Phone size={15} className="mt-0.5 text-indigo-300" /> +91 90000 00000</li>
              <li className="flex items-start gap-2"><MapPin size={15} className="mt-0.5 text-indigo-300" /> Level 7, Prestige Tower,<br />Bengaluru, India</li>
            </ul>
          </div>
        </div>

        <div className="mt-12 pt-6 border-t border-slate-800 flex flex-col sm:flex-row items-center justify-between gap-3 text-xs text-slate-500">
          <p>© 2026 CareerConnect. All Rights Reserved.</p>
          <p className="flex items-center gap-4">
            <Link to="/privacy" className="hover:text-slate-300">Privacy Policy</Link>
            <Link to="/terms" className="hover:text-slate-300">Terms &amp; Conditions</Link>
          </p>
        </div>
      </div>
    </footer>
  );
}
